import { Navigate, useLocation } from "react-router-dom";
import { UserInfoModel } from "app/model/ua/user-info";
import { useAppSelector } from "app/store/hook";
import { BaseRouter } from "app/model/common/baseRouter";
import { UserInfoUtil } from "app/utils/userInfoUtil";
import { AuthConstant } from "app/constants/authConstant";
import { pvMaintRouter } from "../routers/pvMaintRouter";

export default function PvMaintGuard({ children }: any) {
  const location = useLocation();
  const url = location.pathname;
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const pvMaintMenuRouter: BaseRouter[] = pvMaintRouter;

  const checkIsAuthorizedPvMaint = (userInfo: UserInfoModel, routers: BaseRouter[], url: string) => {
    if (UserInfoUtil.hasRole(userInfo, AuthConstant.R006)) {
      const findBrokerRouter: BaseRouter | undefined = routers.find(router => url && url === router.path);
      if (findBrokerRouter) {
        return children;
      } else {
        return <Navigate to="/not-found" replace />;
      }
    }

    return <Navigate to="/not-permission" replace />;
  };

  return checkIsAuthorizedPvMaint(userInfo, pvMaintMenuRouter, url);
}